import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2V22H2V2H22ZM7.7844 18.1766L10.1766 6.21547L8.21547 5.82324L5.82324 17.7844L7.7844 18.1766ZM18.1766 17.7844L15.7844 5.82324L13.8232 6.21547L16.2155 18.1766L18.1766 17.7844ZM12.9999 9.99994V6.99994H10.9999V9.99994H12.9999ZM12.9999 13.9999V10.9999H10.9999V13.9999H12.9999ZM12.9999 17.9999V14.9999H10.9999V17.9999H12.9999Z"}}]};

const StreetRoad1Filled = Vue.extend<IconProps>({
  name: 'StreetRoad1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'street-road-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default StreetRoad1Filled;
